// `/organization/pending?token=${encodeURI(token)}`
// const path = "/v2/organization/writer";
/**
 * @param {Object} param0
 * @param {import("axios").AxiosInstance} param0.repository
 */
export default function actions({ repository } = {}) {
  const path = `/v2/organization/pending`;
  return {
    async acceptInvite({ token }) {
      return await repository
        .put(path, {}, { params: { token: token } })
        .then(data => {
          console.log("[Invite]", "Request Finished", data.data);
          Promise.resolve(true);
        });
    },
    /**
     * @typedef {Object} Response
     * @property {String} email
     */
    /**
     *
     *
     * @param {Object} param0
     * @param {String} param0.token
     * @returns {Response}
     */
    async getDetails({ token }) {
      return await repository
        .put(path, {}, { params: { token: token } })
        .then(data => {
          Promise.resolve(true);
        })
        .catch(err => {
          return Promise.resolve(err.response.data.object);
        });
    }
  };
}
